"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_student_view_document_controller_1 = __importDefault(require("./admin-student-view-document.controller"));
var admin_student_view_document_html_1 = __importDefault(require("./admin-student-view-document.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.documents.view", {
        url: "/:documentId",
        controller: admin_student_view_document_controller_1.default,
        controllerAs: "vm",
        template: admin_student_view_document_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.documents.view", [])
    .config(config)
    .controller("AdminStudentViewDocumentController", admin_student_view_document_controller_1.default);
